enum DocumentType {
  Worksheets = 0,
  Labels = 1
}

export default DocumentType;
